<template>
  <router-view/>
</template>

<style lang="scss">
@use 'assets/scss/style';
</style>
